/**
 * Generated by Kubb (https://kubb.dev/).
 * Do not edit manually.
 */

import { dealflowVerifiedCriterionDtoSchema } from "./dealflowVerifiedCriterionDtoSchema.ts";
import { z } from "zod/v4";

export const dealflowVerifiedInfoDtoSchema = z.object({
  get internalBusinessPlan() {
    return z.array(dealflowVerifiedCriterionDtoSchema).optional();
  },
  get externalFinancialModel() {
    return z.array(dealflowVerifiedCriterionDtoSchema).optional();
  },
});
